import {
  PO_AMEND_PATCH_REQUEST,
  PO_AMEND_PATCH_SUCCESS,
  PO_AMEND_PATCH_ERROR,
  RESET_PO_AMEND_PATCH,
} from "redux/actions/action-type";

const initialState = {
  patchOrders: {},
  amendPatchError: {},
  amendPatchMetadata: {},
  isPOAmendPatchLoading: false,
  isPOAmendPatchError: false,
  isPOAmendPatchSuccess: false,
};

const amendPoFetchOrdersReducer = (state = initialState, action) => {
  switch (action.type) {
    case PO_AMEND_PATCH_REQUEST:
      return {
        ...state,
        isPOAmendPatchLoading: true,
        isPOAmendPatchError: false,
        isPOAmendPatchSuccess: false,
      };

    case PO_AMEND_PATCH_SUCCESS:
      return {
        ...initialState,
        isPOAmendPatchLoading: false,
        patchOrders: action.payload,
        amendPatchMetadata: action.payload,
        isPOAmendPatchError: false,
        isPOAmendPatchSuccess: true,
        amendPatchError: {},
      };

    case PO_AMEND_PATCH_ERROR:
      return {
        ...state,
        isPOAmendPatchLoading: false,
        patchOrders: {},
        isPOAmendPatchError: true,
        isPOAmendPatchSuccess: false,
        amendPatchError: action.payload,
      };

    case RESET_PO_AMEND_PATCH:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default amendPoFetchOrdersReducer;
